import { useAppConfig } from "./use-app-config"

export const useUpdatesInProgress = (): boolean | undefined => {

    // hooks
    const appConfig = useAppConfig()

    return appConfig?.updatesInProgress

}